import React, { FC, useContext } from 'react';

import { useLazyQuery } from '@apollo/client';
import { LocationIcon, OpenedEyeIcon } from '@smartshell/ui-kit';

import { GET_ADVERTISEMENT } from 'schemas';
import { ETheme, ThemeContext } from 'theme';
import { getAdvertisementImageUrl } from 'utils/advertisementImage';

import { formatSum } from '../../../../../../utils';
import {
  AdvertisementEdgeIcon,
  AdvertisementEdgeIconDark,
} from './AdvertisementEdgeIcon';
import s from './AdvertisementItem.module.scss';
import { IAdvertisementItemProps } from './interfaces';

export const AdvertisementItem: FC<IAdvertisementItemProps> = ({
  data,
  setAdvertisementViewState,
}) => {
  const [getAdvertisement] = useLazyQuery(GET_ADVERTISEMENT);
  const { theme } = useContext(ThemeContext);

  return (
    <div
      className={s.container}
      rel="noreferrer"
      onClick={() => {
        if (data?.id) {
          getAdvertisement({
            variables: { id: data.id },
            fetchPolicy: 'network-only',
          });
        }
        setAdvertisementViewState({
          mode: data?.__typename === 'MyAdvertisement' ? 'my' : 'other',
          advertisement: data,
        });
      }}
    >
      <div className={s.edge}>
        {theme === 'light' ? (
          <AdvertisementEdgeIcon />
        ) : (
          <AdvertisementEdgeIconDark />
        )}
      </div>
      <div className={s.header}>
        {data?.images?.[0].length ? (
          <div
            className={s.blur}
            style={{
              backgroundImage: `url(${getAdvertisementImageUrl(
                data.images[0],
                248
              )})`,
            }}
          >
            <img
              className={s.image}
              alt="#"
              src={getAdvertisementImageUrl(data.images[0], 248)}
              srcSet={`
                ${getAdvertisementImageUrl(data.images[0], 248)} 1x,
                ${getAdvertisementImageUrl(data.images[0], 496)} 2x,
                ${getAdvertisementImageUrl(data.images[0], 744)} 3x,
      `}
            />
          </div>
        ) : (
          <img
            className={s.image}
            src={`/images/Advertisement/emptyAdvertisementImage${
              theme === ETheme.DARK ? 'Dark' : 'White'
            }.png`}
            alt="placeholder_image"
          />
        )}

        <div className={s.label}>
          <OpenedEyeIcon color="light" />
          <span className={s.label_text}>{data?.metrics?.views}</span>
        </div>
      </div>
      <div className={s.main}>
        <p className={s.text}>{data?.title}</p>
        {data && (
          <span className={s.cost}>
            {formatSum(data?.price, data.currency.letter)}
          </span>
        )}

        <div className={s.footer}>
          <span className={s.club_name}>{data?.company?.name}</span>
          <div className={s.club_loc}>
            <LocationIcon size="s" color="secondary" />
            <span className={s.loc}>{data?.company?.city}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
